export function parseUserStoragePath(path?: string) {
  const [collection, userId, directory, fileName, ...remaining] =
    path?.split("/") ?? [];

  if (
    collection !== "users" ||
    directory !== "images" ||
    !userId ||
    !fileName ||
    remaining.length
  ) {
    throw new Error("Invalid image path.");
  }

  return { collection, userId, directory, fileName };
}
